import type { FormState } from 'react-hook-form';
import type { FeeFormInputs } from './useFeeForm';

export type FeeFlatFeeBasis = 'reservation' | 'night' | 'guest' | 'guestNight';

export const DEFAULT_FEE_FLAT_FEE_BASIS: FeeFlatFeeBasis = 'reservation';

export const FEE_FLAT_FEE_BASIS_OPTIONS: {
  label: string;
  value: FeeFlatFeeBasis;
}[] = [
  {
    label: 'Per reservation',
    value: 'reservation',
  },
  {
    label: 'Per night',
    value: 'night',
  },
  {
    label: 'Per guest',
    value: 'guest',
  },
  {
    label: 'Per guest per night',
    value: 'guestNight',
  },
];

const FLAT_FEE_FORMULA_BY_BASIS: Record<FeeFlatFeeBasis, string> = {
  reservation: '"rate"',
  night: '"rate" * "nights"',
  guest: '"rate" * "guests"',
  guestNight: '"rate" * "guests" * "nights"',
};

export const getFlatFeeFormula = (flatFeeBasis: FeeFlatFeeBasis | undefined) =>
  FLAT_FEE_FORMULA_BY_BASIS[flatFeeBasis ?? DEFAULT_FEE_FLAT_FEE_BASIS];

export const getFlatFeeBasisFromFormula = (
  formula: string | null | undefined
): FeeFlatFeeBasis => {
  const normalizedFormula = formula?.replaceAll(/\s+/g, ' ').trim() ?? '';
  const hasGuests = /"guests"|"reservation\.guests"/.test(normalizedFormula);
  const hasNights = /"nights"|"reservation\.nights"/.test(normalizedFormula);

  if (hasGuests && hasNights) {
    return 'guestNight';
  }

  if (hasGuests) {
    return 'guest';
  }

  if (hasNights) {
    return 'night';
  }

  return DEFAULT_FEE_FLAT_FEE_BASIS;
};

export const shouldUpdateFeeFormula = (
  dirtyFields: FormState<FeeFormInputs>['dirtyFields']
) =>
  Boolean(
    dirtyFields.type ||
      dirtyFields.rateType ||
      dirtyFields.flatFeeBasis ||
      dirtyFields.linkedAccountIds
  );
